import css from "./index.module.css";
import { nodeIconPaths } from "../../../../../assets/missionIcons/index.js";

/**
 * Displays a Node in the skilltree, as Heaxagon with matching image and additional data
 * @param {Object} data id: 64 character uuid string, name: string, x: number, y: number, missionNumber: string, path: string, missionText: string
 * @param {String} studentId 64 character uuid of given student
 * @param {Array} studentToMission Array of missions started/finished by the given student
 * @param {Boolean} isSelected determines if this node is selected / was clicked last
 * @param {Function} setSelectedNode sets the state of selectedNode to the id of this data.id
 * @param {Function} handleUnlock determines if an mission id is unlocked throgh the parent node
 */
const Node = ({data, studentId, studentToMission, isSelected, setSelectedNode}) => {
  const xOffset = 40;
  /**
   * Checks if the node was previously selected and sets the new values
   */
  const handleClick = () => {
    if(isSelected || !isUnlocked){
      setSelectedNode("");
    } else {
      setSelectedNode(data.id);
    }
  }

  const hasStarted = studentToMission?.filter(e => e.mission_id === data?.id).length > 0;
  const isCompleted = studentToMission?.filter(e => e.mission_id === data?.id && e.completed === true).length > 0;
  const isUnlocked = studentToMission?.filter(e => e.mission_id === data.prequisite_id && e.completed === true).length > 0 || data.prequisite_id === "";
  let style = "";
  let state = "";

  if (isCompleted) {
    style = css.completed;
    state = "ABGEGEBEN";
  } else if (hasStarted) {
    style = css.unlocked;
    state = "FORTFAHREN";
  } else if (isUnlocked)  {
    style = css.unlocked;
    state = "STARTEN";
  } else {
    style = css.locked;
  }
  return (
    <svg width="60" height="52" x={data.x + xOffset} y={data.y} className={css.svg} onClick={() => handleClick()}>
      {isSelected &&  <NodeInfo text={data.name}  state={state} link={"http://localhost:3000/student/" + studentId + "/mission/" + data.id}/>}
      <svg className={css.svg}>
        <path d="M0 25.980762113533157L15 0L45 0L60 25.980762113533157L45 51.96152422706631L15 51.96152422706631Z" className={style}></path>
        <svg className={css.svg}>
          <path d={nodeIconPaths[data.number]} className={css.icon}/>
        </svg>
      </svg>
    </svg>
  )
}

const NodeInfo = ({text, state, link}) => {
  let length = text.length * 12;
  if (length % 2 !== 0) {
    length -= 1;
  }
  if(length < 100) {
    length = 100;
  }

  let yOffset = -100
  let string = `M${(length/2 * -1) +30} ${yOffset} L ${(length/2) +30} ${yOffset} L ${(length/2) +30} ${yOffset + 80} L 50 ${yOffset + 80} L 30 ${yOffset + 90} L 0 ${yOffset + 80} L ${(length/2 * -1) +30} ${yOffset + 80} Z`;
  
  let xStateOffset = -5;
  if(state === "FORTFAHREN") {
    xStateOffset = -20
  } else if (state === "ABGEGEBEN") {
    xStateOffset = -15;
  }

  return (
    <svg className={css.info}>
      <path d={string} />
      <text x={(length/2 * -1) +40} y={-70} className={css.infotext}>{text}</text>
      <text x={xStateOffset} y={-40} onClick={() => window.location.href = link}>{state}</text>
    </svg>
  )
}

export default Node;